import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "./logger.service";

var CryptoJS = require("crypto-js");

@Injectable({
  providedIn: "root"
})

/**
 *
 *  Il servizio {@link SecuretyDataProtectionService} crypta e decryta una stringa passata in input
 *
 */
export class SecuretyDataProtectionService {
  private _logContext: string = "Securety-data-protection.service";

  constructor(
    private _loggerService: LoggerService
  ) { }

  /**
   * Il medoto {@link encrypt} crypta tramite codifica AES una stringa presa in input
   *
   * @param value  generic string to encrypt
   *
   * @returns encrypt string value
   *
   */
  public encrypt(value: string, privateKey?: string): string {
    let keys = environment.AESSecuretyPrivateKey;

    if (privateKey) {
      keys = privateKey;
    }

    const valueParsed = CryptoJS.enc.Utf8.parse(value);

    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Utf8.parse(keys);

    const encrypted = CryptoJS.AES.encrypt(valueParsed, key, {
      keySize: 128,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }

  /**
   * Il medoto {@link decrypt} decrypta tramite codifica AES una stringa presa in input
   *
   * @param value  stringa da decryptare
   *
   * @returns risultato della decryptazione
   *
   */
  public decypt(value: string, privateKey?: string): string {
    let keys = environment.AESSecuretyPrivateKey;

    if (privateKey) {
      keys = privateKey;
    }

    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Utf8.parse(keys);
    let returnString = "";

    try {
      const decrypted = CryptoJS.AES.decrypt(value, key, {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      returnString = decrypted.toString(CryptoJS.enc.Utf8);
    }
    catch (ex) {
      this._loggerService.log(LogLevel.LOG_ERROR, this._logContext, this._logContext, "decypt()", "Error: " + ex.message);
    }

    return returnString;

  }
}
